(function () {
  var customSelect = document.getElementById('product-selectbox_custom');
  if (!customSelect) return;

  var allVariants = Array.from(customSelect.querySelectorAll('option'));
  if (!allVariants.length) return;

  var productVariants = customSelect.closest('product-variants');
  if (!productVariants) return;

  var optionGroups = [];
  var optionIndex = 1;

  while (optionIndex <= 3) {
    var name = 'option' + optionIndex;
    var radios = Array.from(
      productVariants.querySelectorAll(
        'input[type="radio"][name="' + name + '"]'
      )
    );
    if (radios.length > 0) {
      optionGroups.push({ type: 'radio', inputs: radios });
      optionIndex++;
      continue;
    }
    var select = productVariants.querySelector(
      'select[name="' + name + '"]'
    );
    if (select) {
      var comboBox = select.closest('combo-box');
      var buttons = comboBox
        ? Array.from(
            comboBox.querySelectorAll(
              '.combo-box__option-item.select_item_match_options'
            )
          )
        : [];
      optionGroups.push({ type: 'dropdown', select: select, buttons: buttons });
      optionIndex++;
      continue;
    }
    break;
  }

  if (!optionGroups.length) return;

  function getSelectedValues() {
    return optionGroups.map(function (group) {
      if (group.type === 'radio') {
        var checked = group.inputs.find(function (input) {
          return input.checked;
        });
        return checked ? checked.value.trim() : '';
      }
      return group.select.value.trim();
    });
  }

  function findVariant(values) {
    var target = values
      .map(function (v) {
        return v.toLowerCase().trim();
      })
      .sort()
      .join(' / ');
    return allVariants.find(function (option) {
      var dv = option.getAttribute('data-value');
      if (!dv) return false;
      var segments = dv
        .trim()
        .toLowerCase()
        .split(' / ')
        .map(function (s) {
          return s.trim();
        })
        .sort()
        .join(' / ');
      return segments === target;
    });
  }

  function updateBadge(button, variant) {
    var el = button.querySelector('.product_varinats-qty_status');
    if (!el || !variant) return;

    var stockStatus = variant.getAttribute('data-stock-status');
    var quantityStatus = variant.getAttribute('quantity-status');

    el.innerHTML = stockStatus;
    el.classList.remove('continue', 'sold', 'availible');
    if (quantityStatus) {
      el.classList.add(quantityStatus);
    }
    button.setAttribute('data-stock-status', stockStatus);
  }

  function updateAllBadges() {
    var selectedValues = getSelectedValues();

    optionGroups.forEach(function (group, groupIndex) {
      if (group.type !== 'dropdown' || !group.buttons.length) return;

      group.buttons.forEach(function (button) {
        var hypothetical = selectedValues.slice();
        hypothetical[groupIndex] = button.getAttribute('value').trim();
        var variant = findVariant(hypothetical);
        updateBadge(button, variant);
      });
    });
  }

  optionGroups.forEach(function (group) {
    if (group.type === 'dropdown' && group.buttons.length) {
      group.buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setTimeout(updateAllBadges, 50);
        });
      });
    }
    if (group.type === 'radio') {
      group.inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          setTimeout(updateAllBadges, 50);
        });
      });
    }
  });

  updateAllBadges();
})();
